/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-favorite': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.064 7.5c-.448 0-.878.18-1.192.5l-.246.251L15.378 8a1.672 1.672 0 00-2.385 0 1.726 1.726 0 000 2.417l2.633 2.665 2.63-2.665a1.726 1.726 0 000-2.417 1.67 1.67 0 00-1.192-.499zM1.25 18.75H2.5v-3.125A3.129 3.129 0 015.625 12.5h3.75a3.129 3.129 0 013.125 3.125v3.125h1.25v-3.125a4.38 4.38 0 00-4.375-4.375h-3.75a4.38 4.38 0 00-4.375 4.375v3.125zM7.5 2.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zm0-1.25a4.375 4.375 0 100 8.75 4.375 4.375 0 000-8.75z"/>'
  }
})
